export default __webpack_public_path__ + "static/media/logo.fef20425.png";